import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
const defaultOptions = {} as const;

export type DeleteWorkflowRuleDefinitionMutationVariables = GraphQLTypes.Exact<{
  workflowRuleDefinitionId: GraphQLTypes.Scalars['String']['input'];
}>;

export type DeleteWorkflowRuleDefinitionMutationResult = { __typename?: 'Mutation' } & {
  deleteWorkflowRuleDefinition?: GraphQLTypes.Maybe<
    { __typename?: 'DeleteWorkflowRuleDefinitionPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const DeleteWorkflowRuleDefinitionDocument = /*#__PURE__*/ gql`
  mutation deleteWorkflowRuleDefinition($workflowRuleDefinitionId: String!) {
    deleteWorkflowRuleDefinition(workflowRuleDefinitionId: $workflowRuleDefinitionId) {
      errors {
        message
        path
      }
    }
  }
`;

/**
 * __useDeleteWorkflowRuleDefinitionMutation__
 *
 * To run a mutation, you first call `useDeleteWorkflowRuleDefinitionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteWorkflowRuleDefinitionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteWorkflowRuleDefinitionMutation, { data, loading, error }] = useDeleteWorkflowRuleDefinitionMutation({
 *   variables: {
 *      workflowRuleDefinitionId: // value for 'workflowRuleDefinitionId'
 *   },
 * });
 */
export function useDeleteWorkflowRuleDefinitionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteWorkflowRuleDefinitionMutationResult,
    DeleteWorkflowRuleDefinitionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };

  return Apollo.useMutation<DeleteWorkflowRuleDefinitionMutationResult, DeleteWorkflowRuleDefinitionMutationVariables>(
    DeleteWorkflowRuleDefinitionDocument,
    options
  );
}
export type DeleteWorkflowRuleDefinitionMutationHookResult = ReturnType<typeof useDeleteWorkflowRuleDefinitionMutation>;
